import React from 'react'

import {
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box
} from '@mui/material'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'

interface CollapseButtonProps {
  header: any
  handleClick: any
  handleChangeProp?: any
  showButton?: boolean
  width?: string
  children?: React.ReactNode
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({
  header,
  children,
  handleClick,
  handleChangeProp,
  showButton = true,
  width
}) => {
  const [checked, setChecked] = React.useState(false)

  const handleChange = () => {
    setChecked((prev) => !prev)
  }

  const getWidth = () => {
    if (width) return width

    return showButton ? '85%' : '100%'
  }

  return (
    <Box
      sx={{
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        mt: '10px'
      }}
    >
      <Box sx={{ width: getWidth() }}>
        <Accordion>
          <AccordionSummary
            aria-controls='panel1a-content'
            id='panel1a-header'
            sx={{ backgroundColor: '#e2e8f0' }}
            onClick={() =>
              handleChangeProp ? handleChangeProp() : handleChange()
            }
          >
            <Typography component='h6'>{header}</Typography>
          </AccordionSummary>
          <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
      </Box>

      {checked && showButton && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '15%',
            height: '100%'
          }}
        >
          <Button
            type='submit'
            variant='contained'
            color='primary'
            onClick={handleClick}
            sx={{
              height: '100%',
              width: '10px',
              minWidth: '10px'
            }}
          >
            <ChevronRightIcon />
          </Button>
        </Box>
      )}
    </Box>
  )
}
